import { useState } from "react";
import { signal } from "@preact/signals-react";

import Dropdown from "componentsv2/form/Dropdown";
import Selection from "componentsv2/form/Selection";
import Checkbox from "componentsv2/form/Checkbox";
import FileField from "components/MeForm/FileField";
import Button from "componentsv2/button/Button";
import { FunnelIcon } from "components/Icons";
import Char from "componentsv2/form/Char";

const warehouse = signal(null);
const supplier = signal(null);
const brand = signal(null);
const file = signal(null);
const rotation = signal(null);
const to_purchase = signal(null);
const product = signal(null);

export default function FilterBar({ type, handleFilter }) {
  const [filtered, setFiltered] = useState(false);

  function searchParty(value) {
    return value ? [["name", "ilike", `%${value}%`]] : [];
  }

  function searchLocation(value) {
    const domain = [["type", "=", "warehouse"]];
    if (value) domain.push(["name", "ilike", `%${value}%`]);
    return domain;
  }

  function onClickFilter() {
    setFiltered(true);
    const params = {
      warehouse: warehouse.value?.id,
      supplier: supplier.value?.id,
      brand: brand.value?.id,
      file: file.value,
      rotation: rotation.value?.id,
      to_purchase: to_purchase.value,
      product: product.value,
    };
    handleFilter(params);
  }

  function onClearFilters() {
    setFiltered(false);
    warehouse.value = null;
    supplier.value = null;
    brand.value = null;
    file.value = null;
    rotation.value = null;
    to_purchase.value = null;
    product.value = null;
    handleFilter({});
  }

  return (
    <div className="flex flex-wrap items-center gap-2 justify-evently bg-white px-4 py-2 rounded-xl shadow-sm my-4">
      <FunnelIcon className="h-5 w-5 text-gray-600" />

      {type === "requisition" && (
        <>
          <div className="flex-grow basis-auto">
            <Dropdown
              name="warehouse"
              placeholder={"Bodega"}
              model="stock.location"
              recSearch={searchLocation}
              data={warehouse}
            />
          </div>
          <div className="flex-grow basis-[400px]">
            <Dropdown
              name="supplier"
              placeholder={"Proveedor"}
              model="party.party"
              recSearch={searchParty}
              data={supplier}
            />
          </div>

          <div className="flex-grow basis-auto">
            <Char
              name="product"
              placeholder="Producto"
              data={product}
              field={{ required: false }}
            />
          </div>
          <div className="flex-grow basis-auto">
            <Dropdown
              name="brand"
              placeholder="Marca"
              model="product.brand"
              recSearch={searchParty}
              data={brand}
            />
          </div>

          <div className="flex-grow basis-auto">
            <Selection
              name="rotation"
              placeholder="Rotación"
              options={[
                { id: null, name: "" },
                { id: "high", name: "High" },
                { id: "medium", name: "Medium" },
                { id: "low", name: "Low" },
              ]}
              data={rotation}
            />
          </div>

          <div className="flex-grow -mt-4">
            <Checkbox
              name="to_purchase"
              label="purchase.request.to_purchase"
              data={to_purchase}
            />
          </div>
        </>
      )}

      {/* Campos tipo suggested */}
      {type === "suggested" && (
        <>
          <div className="flex-grow basis-auto">
            <FileField
              field={{
                // label: "Upload File",
                name: "file_upload",
                required: true,
                accept: ".xls, .xlsx",
              }}
              attrs={{ level: "wizard" }}
              data={file}
            />
          </div>

          <div className="flex-grow basis-[400px]">
            <Dropdown
              name="supplier"
              placeholder={"Proveedor"}
              model="party.party"
              recSearch={searchParty}
              data={supplier}
            />
          </div>
        </>
      )}
      <div className="flex-grow basis-auto -mr-4">
        <div className="flex flex-row ">
          <Button
            color="neutralDark"
            size="text-sm text-gray-700 !h-10 min-w-[160px]"
            onClick={onClickFilter}
          >
            Aplicar
          </Button>
          {filtered && (
            <Button
              onClick={onClearFilters}
              color="text-sm text-gray-700 hover:shadow-none border-none"
              size={"w-full md:w-fit"}
            >
              Limpiar
            </Button>
          )}
        </div>
      </div>
    </div>
    // </div>
  );
}
